// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1RCww","form":"styles_form__2KW7E"};